import { render, staticRenderFns } from "./StudentExamRequest.vue?vue&type=template&id=01f0a798&scoped=true&"
import script from "./StudentExamRequest.vue?vue&type=script&scoped=true&lang=js&"
export * from "./StudentExamRequest.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./StudentExamRequest.vue?vue&type=style&index=0&id=01f0a798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0a798",
  null
  
)

export default component.exports